export default __webpack_public_path__ + "static/media/ThaiSansNeue-Bold.d3a5ae41.otf";